import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import "bootstrap";

import Toast from "@/shared/support/Toast";
import Debug from "@/shared/support/Debug";

import AButton from "@/shared/components/common/AButton.vue";
import AuggieIcon from "@/shared/components/common/AuggieIcon.vue";
import BatteryPanel from "@/components/BatteryPanel.vue";
import ButtonButton from "@/shared/components/common/ButtonButton.vue";
import BoolDisplay from "@/shared/components/common/BoolDisplay.vue";
import FormLabel from "@/shared/components/common/FormLabel.vue";
import FormRow from "@/shared/components/common/FormRow.vue";
import GridPanel from "@/shared/components/common/GridPanel.vue";
import HeaderMessage from "@/shared/components/common/HeaderMessage.vue";
import Help from "@/components/Help.vue";
import Loading from "@/shared/components/common/Loading.vue";
import Numeric from "@/shared/components/common/Numeric.vue";
import Selection from "@/shared/components/common/Selection.vue";
import SpinButton from "@/shared/components/common/SpinButton.vue";
import SpinX from "@/shared/components/common/SpinX.vue";
import UploadPanel from "@/shared/components/common/UploadPanel.vue";
import ValidationMessage from "@/shared/components/common/ValidationMessage.vue";

import "@/styles/app.scss";
import "@progress/kendo-theme-default/dist/all.css";


// Register all fontawesome icons
// https://github.com/FortAwesome/vue-fontawesome
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faAsterisk, faBolt, faBoxOpen, faCar, faCheckCircle,
    faChevronDown, faChevronLeft, faChevronRight, faChevronUp,  faCogs,
    faEdit, faFileDownload, faHome, faImages, faSearch, faSpinner, faSyncAlt, faPlus, faTabletAlt, faTimes, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

library.add(
    faAsterisk, faBolt, faBoxOpen, faCar, faCheckCircle,
    faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faCogs,
    faEdit, faFileDownload, faHome, faImages, faSearch, faSpinner, faSyncAlt, faPlus, faTabletAlt, faTimes, faTimesCircle,
);

const appObject = createApp(App);

Toast.initializeToaster(appObject);
Debug.initialize();

// register commonly used components
appObject.component("AButton", AButton);
appObject.component("AuggieIcon", AuggieIcon);
appObject.component("BatteryPanel", BatteryPanel);
appObject.component("ButtonButton", ButtonButton);
appObject.component("BoolDisplay", BoolDisplay);
appObject.component("FaIcon", FontAwesomeIcon);
appObject.component("FormLabel", FormLabel);
appObject.component("FormRow", FormRow);
appObject.component("GridPanel", GridPanel);
appObject.component("HeaderMessage", HeaderMessage);
appObject.component("Help", Help);
appObject.component("Loading", Loading);
appObject.component("Numeric", Numeric);
appObject.component("Selection", Selection);
appObject.component("SpinButton", SpinButton);
appObject.component("SpinX", SpinX);
appObject.component("UploadPanel", UploadPanel);
appObject.component("ValidationMessage", ValidationMessage);

appObject.use(router);

appObject.mount("#app");

export default appObject;

dom.watch();
// This will kick of the initial replacement of i to svg tags and configure a MutationObserver


